<template>
  <v-container>
    <h1>{{ user.unique_name }} is logged in</h1>
    <parameter ref="param" @error="onError" @data="onData" @id="onId"></parameter>
  </v-container>
</template>

<script>
import paramCtrl from "@/components/controls/parameter";
import store from "@/store";

export default {
  
  name: "account-loggedin",

  components: {
    "parameter": paramCtrl,
  },

  data: () => ({
    user: {
      id: "",
      username: "",
      unique_name: "",
    },
  }),

  mounted() {
    // console.log("loggedIn.mounted()", this.$route.params.id);
    this.$refs.param.get(this.$route.params.id)
  },

  methods: {

    onData(data) {
      // console.log("Data:", data);
      this.user = JSON.parse(data.jsonData);
      const rolesUrl = "User/Roles/id?id=" + this.user.id;
      this.get(rolesUrl, this.onUserRoles, this.onUserRolesError);
    },

    onError() {
      // console.log(error);
    },

    onUserRoles(data) {
      if(data != null) {
          var roles = data.data;
          var userRoles = [];
          roles.forEach(role => {
              userRoles.push(role.roleName);
          });
          this.user.userRoles = userRoles;
          store.commit("setUser", this.user);
          store.commit("updateMenu");
      }
    },

    onUserRolesError() {
        // console.log("User Roles Error: ", error);
    },

    onId() {

    },
  }
}
</script>

<style>

</style>